<template>
<div class="chapter">
<div class="inner_page">
<p class="ser"><img alt="image" src="Images/p4-001.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781617752674_Split5.vue?5e8d78bf